module.exports = __webpack_public_path__ + "img/oog_ow.254cfb07.png";